<html>

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <!-- Bootstrap CSS -->
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
    integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk" crossorigin="anonymous">


</head>

<body>
  <app-ind></app-ind>
  <table class="table table-hover w-50"
    style="background-color: white; margin-top: 100px;  box-shadow: 0px 0px 19px 5px rgba(0, 0, 0, 0.5);">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">E-mail</th>
        <th scope="col">Block</th>
        <th scope="col">Unblock</th>
        <th scope="col">Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users;index as i">
        <th scope="row">{{i+1}}</th>
        <td>{{user.name}}</td>
        <td>{{user.email}}</td>
        <td>
          <button class="btn btn-link" [disabled]="user.blocked" (click)="block(user)"><i class="fa fa-ban"
              aria-hidden="true"></i></button></td>
        <td><button class="btn btn-link" [disabled]="!user.blocked" (click)="unblock(user)"><i class="fa fa-unlock"
              aria-hidden="true"></i></button></td>
        <td><button class="btn btn-link" (click)="delete(user)"><i class="fa fa-trash" aria-hidden="true"></i></button>
        </td>

      </tr>

    </tbody>
  </table>
</body>

</html>